"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesEndpointKeys = void 0;
var SalesEndpointKeys;
(function (SalesEndpointKeys) {
    SalesEndpointKeys["GetSalesInfo"] = "sales.getSalesInfo";
    SalesEndpointKeys["GetOffers"] = "sales.getOffers";
    SalesEndpointKeys["GetMainOffers"] = "sales.getMainOffers";
    SalesEndpointKeys["GetMembershipClassAndOffersBySubdomain"] = "sales.getMembershipClassAndOffersBySubdomain";
    SalesEndpointKeys["GetGroupsInfo"] = "groups.getGroupsInfo";
    SalesEndpointKeys["PutSalesInfo"] = "sales.updateSalesInfo";
    SalesEndpointKeys["PutGroupsInfo"] = "groups.updateGroupsInfo";
    SalesEndpointKeys["PostUserAreaEvent"] = "sales.user.event";
    SalesEndpointKeys["GetSalesDiaglogAlert"] = "sales.dialog.alert";
    SalesEndpointKeys["GetSalesCampaign"] = "sales.campaign";
    SalesEndpointKeys["GetSalesCampaignAmount"] = "sales.campaign.sales.amount";
    SalesEndpointKeys["PostSalesCampaignActivate"] = "sales.campaign.activate";
    SalesEndpointKeys["PostSalesCampaignInactivate"] = "sales.campaign.inactivate";
    SalesEndpointKeys["GetSignupAllowed"] = "get.signup.allowed";
    SalesEndpointKeys["GetAccessPlusShow"] = "get.accessPlus.show";
    SalesEndpointKeys["GetIsAccessPlus"] = "get.is.accessPlus";
    SalesEndpointKeys["PostSignupAllowed"] = "update.signup.allowed";
    SalesEndpointKeys["PostFreeSignup"] = "update.free.signup";
    SalesEndpointKeys["PutConfigAdd"] = "config.add";
    SalesEndpointKeys["DeleteConfig"] = "config.remove";
})(SalesEndpointKeys || (exports.SalesEndpointKeys = SalesEndpointKeys = {}));
